import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';

export const CHILD_COMPONENT_FETCH_INIT = createAction('CHILD_COMPONENT_FETCH_INIT');
export const CHILD_COMPONENT_FETCH_SUCCESS = createAction('CHILD_COMPONENT_FETCH_SUCCESS');
export const CHILD_COMPONENT_FETCH_FAIL = createAction('CHILD_COMPONENT_FETCH_FAIL');

export const CHILD_COMPONENT_CREATE_INIT = createAction('CHILD_COMPONENT_CREATE_INIT');
export const CHILD_COMPONENT_CREATE_SUCCESS = createAction('CHILD_COMPONENT_CREATE_SUCCESS');
export const CHILD_COMPONENT_CREATE_FAIL = createAction('CHILD_COMPONENT_CREATE_FAIL');

export const CHILD_COMPONENT_UPDATE_INIT = createAction('CHILD_COMPONENT_UPDATE_INIT');
export const CHILD_COMPONENT_UPDATE_SUCCESS = createAction('CHILD_COMPONENT_UPDATE_SUCCESS');
export const CHILD_COMPONENT_UPDATE_FAIL = createAction('CHILD_COMPONENT_UPDATE_FAIL');

export const CHILD_COMPONENT_DELETE_INIT = createAction('CHILD_COMPONENT_DELETE_INIT');
export const CHILD_COMPONENT_DELETE_SUCCESS = createAction('CHILD_COMPONENT_DELETE_SUCCESS');
export const CHILD_COMPONENT_DELETE_FAIL = createAction('CHILD_COMPONENT_DELETE_FAIL');

export const CHILD_COMPONENT_CLEAR = createAction('CHILD_COMPONENT_CLEAR');

export const fetchChildComponents = ({ siteId, masterConfigId, childComponentCategoryIds, type }) => {
  return async (dispatch) => {
    dispatch(CHILD_COMPONENT_FETCH_INIT());

    try {
      const params = { siteId };
      if (childComponentCategoryIds && childComponentCategoryIds !== 'all') {
        params.childComponentCategoryIds = childComponentCategoryIds;
      }
      if (type) {
        params.type = type;
      }
      const res = await axios.get(`${url}/childComponent/`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      return dispatch(
        CHILD_COMPONENT_FETCH_SUCCESS({ list: res.data.data })
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_COMPONENT_FETCH_FAIL({ error }));
    }
  };
};

export const createChildComponent = ({ masterConfigId, childTitle, childComponentCategoryIds, dynamicData, mediaFiles }, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_COMPONENT_CREATE_INIT());

    try {
      const formData = new FormData();
      formData.append('masterConfigId', masterConfigId);
      formData.append('childTitle', childTitle);
      if (childComponentCategoryIds && childComponentCategoryIds.length > 0) {
        formData.append('childComponentCategoryIds', JSON.stringify(childComponentCategoryIds));
      }

      const dynamicDataClean = { ...dynamicData };
      if (mediaFiles) {
        Object.keys(mediaFiles).forEach((fieldId) => {
          formData.append(fieldId, mediaFiles[fieldId]);
          delete dynamicDataClean[fieldId];
        });
      }

      formData.append('dynamicData', JSON.stringify(dynamicDataClean));

      const res = await axios.post(
        `${url}/childComponent/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      toastr.success('', 'Child component created successfully');
      dispatch(
        CHILD_COMPONENT_CREATE_SUCCESS({ child: res.data.data })
      );

      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_COMPONENT_CREATE_FAIL({ error }));
    }
  };
};

export const updateChildComponent = ({ id, masterConfigId, childTitle, childComponentCategoryIds, dynamicData, mediaFiles }, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_COMPONENT_UPDATE_INIT());

    try {
      const formData = new FormData();
      formData.append('childTitle', childTitle);
      if (masterConfigId) {
        formData.append('masterConfigId', masterConfigId);
      }
      if (childComponentCategoryIds && childComponentCategoryIds.length > 0) {
        formData.append('childComponentCategoryIds', JSON.stringify(childComponentCategoryIds));
      }

      const dynamicDataClean = { ...dynamicData };
      if (mediaFiles) {
        Object.keys(mediaFiles).forEach((fieldId) => {
          formData.append(fieldId, mediaFiles[fieldId]);
          delete dynamicDataClean[fieldId];
        });
      }

      formData.append('dynamicData', JSON.stringify(dynamicDataClean));

      const res = await axios.put(
        `${url}/childComponent/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      toastr.success('', 'Child component updated successfully');
      dispatch(
        CHILD_COMPONENT_UPDATE_SUCCESS({ child: res.data.data })
      );

      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_COMPONENT_UPDATE_FAIL({ error }));
    }
  };
};

export const deleteChildComponent = (id, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_COMPONENT_DELETE_INIT());

    try {
      await axios.delete(`${url}/childComponent/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      toastr.success('', 'Child component deleted successfully');
      dispatch(CHILD_COMPONENT_DELETE_SUCCESS({ id }));

      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_COMPONENT_DELETE_FAIL({ error }));
    }
  };
};
